var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{staticClass:"employee-card"},[_c('div',{staticClass:"section"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._t("btn")],2),_vm._t("content")],2)}
var staticRenderFns = []

export { render, staticRenderFns }